module.exports = __webpack_public_path__ + "static/media/German_cooperation.a43548c6.png";